<template>
  <div class="uuidRecord">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      
      <el-table-column prop="itemCode" label="物料编码" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.itemCode.code"
            placement="top"
            min-width="100px"
            :open-delay="300"
          >
            <span
              class="textOverflow"
              v-if="scope.row.itemCode"
            >
              {{ scope.row.itemCode.code }}
            </span>
          </el-tooltip>
          <span v-if="!scope.row.itemCode">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="dateTime" label="时间" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.dateTime"
            placement="top"
            min-width="100px"
            :open-delay="300"
          >
            <span
              class="textOverflow"
              v-if="scope.row.dateTime"
            >
              {{ scope.row.dateTime }}
            </span>
          </el-tooltip>
          <span v-if="!scope.row.dateTime">-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderNumber"
        label="组装工单"
        align="center"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
        <template v-if="scope.row.customerOrder">
          <span>
            {{ scope.row.productionOrder.orderNumber }}
          </span>
        </template>
        <span v-else>-</span>
      </template>
      </el-table-column>      
      <el-table-column prop="store" label="扣减前库存" align="center">
        <template slot-scope="scope">
           <div class="textOverflow" v-if="scope.row.store">
              {{ scope.row.store }}
            </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="出入库数量" align="center">
        <template slot-scope="scope">
         <div class="textOverflow" :class="{danger: scope.row.quantity < 0}" v-if="scope.row.quantity">
              {{ scope.row.quantity }}
            </div>
          <span v-if="!scope.row.quantity">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="经手人" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.user.name+scope.row.user.employeeNum"
            placement="top" min-width="120px" :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.user">
              {{ scope.row.user.name }}({{scope.row.user.employeeNum}})
            </div>
          </el-tooltip>
          <span v-if="!scope.row.user">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="notes" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.notes"
            placement="top" min-width="100px" :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.notes">
              {{ scope.row.notes }}
            </div>
          </el-tooltip>
          <span v-if="!scope.row.notes">-</span>
        </template>
      </el-table-column>
          
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getUuidRecords"
    ></pagination>
  </div>
</template>

<script>

import pagination from "@/components/pagination.vue";
import {
  apiUuidRecordSearch,
  apiExportUuidRecord,
} from "@/api/itemCodeManage.js";
export default {
  components: {
    pagination
  },
  props: {
    twoTabPaneValue: {
      type: String,
    },
    uuidRecordSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: true,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      multipleSelection: [],
    };
  },
  methods: {
    // 表格数据
    async getUuidRecords() {
      const res = await apiUuidRecordSearch({
        ...this.uuidRecordSearchForm,
        itemCode: this.twoTabPaneValue,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getUuidRecords();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getUuidRecords();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getUuidRecords();
    },
    // 产品列表表格导出
    tableExport() {
      this.$confirm(`确定导出物料使用记录吗？`, `导出`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = {};
        res = await apiExportUuidRecord({
          itemCode: this.twoTabPaneValue
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
};
</script>

<style lang="less" scoped>
.uuidRecord {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
</style>
